function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3204 15.4939C19.558 12.7768 23.6937 11.2065 28.1097 11.2065C30.3858 11.2065 32.7182 11.8447 34.7765 13.1748L52.8785 24.8551C55.4279 26.5021 56.9999 29.3372 56.9999 32.4202C56.9999 38.6811 50.7592 43.0469 44.8643 40.8568C43.3426 40.2907 41.6705 40.2774 40.14 40.8194C38.8005 41.2914 36.9883 41.7973 35.1182 41.9139M32.0151 45.1079V45.1113C32.2346 48.3426 31.9392 51.8671 30.4437 54.8777C29.8927 55.9881 28.7659 56.6954 27.5272 56.6954H11.2861C9.40803 56.6954 7.91484 55.1023 8.04724 53.2185L9.79394 28.2891C10.1299 23.5173 12.2658 19.2764 15.5105 16.216C15.6083 16.1182 15.9611 15.7942 16.3205 15.495",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.9959 6.1929C23.7751 3.07701 20.4921 0.0132087 18.165 0.794181C14.7463 1.9396 14.6798 10.9519 15.8289 14.3816C15.9578 14.7672 16.123 15.1398 16.3222 15.4942V15.4953M28.4644 11.2125C28.4075 10.8771 28.3243 10.5468 28.2155 10.2245C27.8489 9.13112 27.04 7.65632 25.997 6.1929",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.28 13.4679C19.2495 13.3962 19.2219 13.3234 19.1974 13.2494C18.8796 12.3009 18.6215 10.1935 18.7449 8.0012L18.7483 7.948C18.8468 6.28426 20.9272 5.58704 22.0076 6.85466C22.0211 6.87055 22.0336 6.88633 22.0471 6.9011C23.4636 8.57284 24.5258 10.4075 24.8438 11.3548C24.8596 11.4001 24.872 11.4442 24.8856 11.4895V11.4907M25.9943 6.19261H25.9954C27.2093 6.06553 28.429 6.00205 29.6495 6.00244H33.0005C38.148 6.00357 41.2251 11.511 38.8822 15.8243M15.1587 9.11607C10.0655 11.4125 5.27898 14.9167 1.72776 19.4156L1.5388 19.6556C0.646182 20.7862 1.609 22.3176 2.93374 22.0233L3.05362 21.9961C4.40101 21.6962 5.39312 23.2355 4.56506 24.3402L1.27751 28.7248C0.508267 29.7514 1.45396 31.1751 2.69847 30.865L2.78669 30.8424C4.01644 30.5345 4.98816 31.8474 4.34681 32.9193L2.42016 36.1314C0.821619 38.798 3.24258 42.0678 6.25645 41.3129L8.92406 40.7073M30.2945 38.2615L46.3093 20.6165M34.2325 39.2134L42.5024 30.1022M49.3389 22.5712L45.1644 27.1709M35.1172 41.9138C34.9611 43.5753 33.6635 44.9053 32.0174 45.1078C32.0163 45.1078 32.0163 45.1079 32.0152 45.109C29.653 45.3881 27.7237 43.366 28.0601 41.056C28.2491 39.7759 29.1179 38.7177 30.2887 38.2615C30.6999 38.1014 31.1373 38.0197 31.5784 38.0205C33.6636 38.0204 35.3105 39.8078 35.1172 41.9138Z",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7426 13.7749L19.323 17.6899C20.4986 25.6066 24.3719 32.8738 30.2876 38.2618L30.2887 38.2629M15.5093 16.2162L15.817 18.2886C17.1217 27.0729 21.4516 35.1257 28.059 41.0562L28.0601 41.0573M19.2743 51.692C22.8611 49.5816 26.0391 46.8427 28.6563 43.6063M9.02344 55.7777L11.2419 55.1416C12.7815 54.7 14.2887 54.152 15.7525 53.5017M17.3488 56.6957C23.1228 54.1125 28.1628 50.1313 32.0139 45.1115C32.015 45.1104 32.0162 45.1093 32.0162 45.1081",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M29.9023 20.6944C29.9023 19.8339 30.5992 19.1353 31.4602 19.1353C32.32 19.1353 33.0169 19.8339 33.0169 20.6944",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgHorse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorse);
export default __webpack_public_path__ + "static/media/horse.080b62a801e992fea4b7e131a1b11e4a.svg";
export { ForwardRef as ReactComponent };